import { useAppStore } from "@/store";
import { observer } from "mobx-react-lite";
import { FC, ReactNode } from "react";
import { useDatabase, useReplComponent } from "./debug-db-repl-page.hooks";

/**
 * Debug page that provides a SQL REPL interface to the PGlite database.
 * Only available in development builds for security.
 */
export const DebugDbReplPage: FC = observer(() => {
  const { store } = useAppStore();
  const { database } = store;

  const { pg, viewState, errorMessage, refresh } = useDatabase({ database });
  const { ReplComponent, loadError } = useReplComponent();

  let content: ReactNode;
  const displayError = errorMessage || loadError;

  if (viewState === "error" && displayError) {
    content = <div>{displayError}</div>;
  } else if (viewState === "ready" && pg) {
    if (import.meta.env.DEV) {
      content = ReplComponent ? <ReplComponent pg={pg} /> : <div>Loading REPL…</div>;
    } else {
      content = <div>REPL is available only in development builds.</div>;
    }
  } else {
    content = <div>Database not initialized.</div>;
  }

  return (
    <div>
      <button type="button" onClick={refresh}>
        Refresh
      </button>

      {content}
    </div>
  );
});
